<template>
  <h2>Persönliche Daten</h2>
  <div class="form-row">
    <div class="col-sm form-group">
      <label for="first_name">Vorname</label>
      <BootstrapField
        type="text"
        name="first_name"
        placeholder="Vorname"
        rules="required"
      />
      <small class="form-text"
        >Wir bitten darum, dass du deinen richtigen Namen angibst, wie er im
        Personalausweis steht.</small
      >
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm form-group">
      <label for="last_name">Nachname</label>
      <BootstrapField
        type="text"
        name="last_name"
        placeholder="Nachname"
        rules="required"
      />
      <small class="form-text"
        >Wir bitten darum, dass du deinen richtigen Nachnamen angibst, wie er im
        Personalausweis steht.</small
      >
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm form-group">
      <label for="password">Passwort</label>
      <BootstrapField
        type="password"
        name="password"
        placeholder="Passwort"
        :rules="pwRules"
      />
    </div>
    <div class="col-sm form-group">
      <label for="password">Passwort wiederholen</label>
      <BootstrapField
        type="password"
        name="password2"
        placeholder="Passwort wiederholen"
        rules="confirmedPassword:@password"
      />
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm form-group">
      <label for="email" class="">E-Mail</label>
      <BootstrapField
        type="email"
        name="email"
        placeholder="E-Mail"
        rules="required"
      />
    </div>
    <div class="col-sm form-group">
      <label for="email">E-Mail wiederholen</label>
      <BootstrapField
        type="email"
        name="email2"
        placeholder="E-Mail Wiederholen"
        rules="confirmedEmail:@email"
      />
    </div>
  </div>
  <div class="form-group" v-if="adminRegistration">
    <div class="form-check">
      <Field
        type="checkbox"
        name="needs_email_confirmation"
        class="form-check-input"
        :value="true"
      />
      <label class="form-check-label" for="needs_email_confirmation">
        Crewmitglied muss E-Mail selbst bestätigen (dann wird eine Bestätigungs
        E-Mail verschickt)
      </label>
    </div>
  </div>
  <div class="form-group">
    <label for="phone">Handynummer</label>
    <BootstrapField
      type="text"
      name="phone"
      placeholder="+49 151 12345678"
      rules="phoneGerman|phoneService|phoneMobile"
    />
    <small class="form-text"
      >Die Handynummer muss stimmen, wir verifizieren den Account
      darüber.</small
    >
  </div>
  <div class="form-group" v-if="adminRegistration">
    <div class="form-check">
      <Field
        type="checkbox"
        name="needs_phone_confirmation"
        class="form-check-input"
        :value="true"
      />
      <label class="form-check-label" for="needs_phone_confirmation">
        Crewmitglied muss Handynummer selbst bestätigen (dann wird eine
        Bestätigungs SMS verschickt)
      </label>
    </div>
  </div>
  <template v-if="dietary_enabled">
    <h2>Essen</h2>
    <div class="form-group">
      <div class="form-check">
        <Field
          class="form-check-input"
          type="radio"
          name="food_preference"
          id="foodPreferenceOmni"
          :value="2"
        />
        <label class="form-check-label" for="foodPreferenceOmni"> Egal </label>
      </div>
      <div class="form-check">
        <Field
          class="form-check-input"
          type="radio"
          name="food_preference"
          id="foodPreferenceVegetarian"
          :value="1"
        />
        <label class="form-check-label" for="foodPreferenceVegetarian">
          Vegetarisch
        </label>
      </div>
      <div class="form-check">
        <Field
          class="form-check-input"
          type="radio"
          name="food_preference"
          id="foodPreferenceVegan"
          :value="0"
        />
        <label class="form-check-label" for="foodPreferenceVegan">
          Vegan
        </label>
      </div>
    </div>
    <div class="form-group">
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="allergies_checkbox"
          v-model="showAllergies"
        />
        <label class="form-check-label" for="allergies_checkbox">
          Ich habe Allergien gegen bestimmte Zutaten
        </label>
      </div>
    </div>
  </template>
  <div class="form-group" v-if="showAllergies">
    <BootstrapField type="text" name="food_allergies" placeholder="Allergien" />
  </div>
  <h2 v-if="!hide_tshirts">Crewshirt</h2>
  <div class="form-group" v-if="!hide_tshirts">
    <div class="form-check">
      <Field
        type="checkbox"
        name="has_shirt"
        class="form-check-input"
        :value="true"
        :disabled="disableShirtCheckbox"
      />
      <label class="form-check-label" for="has_shirt">
        Ja, ich habe schon ein T-Shirt
      </label>
      <small class="form-text" v-if="disableShirtCheckbox"
        >Wenn du ein neues Shirt benötigst, melde dich bei einem Admin</small
      >
    </div>
  </div>
  <div class="form-group" v-if="!hide_tshirts">
    <label for="shirt_size">T-Shirt Größe</label>
    <Field
      name="shirt_size"
      rules="required"
      v-slot="{ field, errors, errorMessage, meta }"
    >
      <select
        v-bind="field"
        class="form-control"
        :class="{
          'is-invalid': !!errors.length,
          'is-valid': meta.valid && meta.dirty,
        }"
      >
        <option value="">-- Auswählen --</option>
        <template v-for="(size, name) of shirtSizes" :key="size">
          <option :value="size" v-if="size < 99">
            {{ name }}
          </option>
        </template>
      </select>
      <span class="invalid-feedback" v-if="!!errors.length">{{
        errorMessage
      }}</span>
    </Field>
    <small class="form-text"
      >Dies ist ein Pflichtfeld, auch wenn du schon ein Shirt hast. Es hilft uns
      bei der Planung, sollten wir neue Shirts verteilen wollen.</small
    >
  </div>
</template>

<script>
import BootstrapField from "./BootstrapField.vue";
import { Field } from "vee-validate";
import shirtsizes from "@/enums/shirtsizes.js";
import { mapState } from "pinia";
import { useConfigStore } from "@/stores/config";

export default {
  name: "UserForm",
  props: ["pwRules", "adminRegistration", "disableShirtCheckbox"],
  components: {
    BootstrapField,
    Field,
  },
  computed: {
    ...mapState(useConfigStore, ["dietary_enabled", "hide_tshirts"]),
  },
  data() {
    return {
      showAllergies: false,
      shirtSizes: shirtsizes,
    };
  },
};
</script>

<style scoped></style>
